import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circletick--color",
  "use": "icon-circletick--color-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68 68\" id=\"icon-circletick--color\">\n<g id=\"icon-circletick--color_circletick--color\">\n\t<circle style=\"fill:#4CBAC0;\" cx=\"34\" cy=\"34\" r=\"34\" fill=\"currentColor\" />\n\t<polygon style=\"fill:#FFFFFF;\" points=\"29.379,51.267 13.705,38.211 17.545,33.602 28.607,42.815 50.484,16.537 55.096,20.375 \t\" />\n</g>\n<g id=\"icon-circletick--color_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol